import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { appIcon } from 'src/assets';

export const useStyles = makeStyles(() => createStyles({
  pageBg: {
    backgroundImage: `url(${appIcon.authBG})`,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    minHeight: '100%',
  },
  infoText: {
    fontWeight: 'bold',
    fontSize: '50px',
    lineHeight: '60px',
    color: '#7051EF',
  },

}));
